export const HOME_NOVEL_REVIEW_SCORE_STYLE = { goodIcon: 'w-12 h-12', score: 'ml-2' };
